import { render, staticRenderFns } from "./DetailContextMenu.vue?vue&type=template&id=6cfdf354&scoped=true"
import script from "./DetailContextMenu.vue?vue&type=script&lang=js"
export * from "./DetailContextMenu.vue?vue&type=script&lang=js"
import style0 from "./DetailContextMenu.vue?vue&type=style&index=0&id=6cfdf354&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfdf354",
  null
  
)

export default component.exports